module.exports = __webpack_public_path__ + "files/11215a974b8dade59e3e91752d658996.png";